module.exports = __webpack_public_path__ + "img/maletin.a3b16681.svg";